export default function Footer() {
  return (
    <footer className="bg-black text-white pt-16 pb-8">
      <div className="border-t border-teal-500/30 mb-12"></div>
      
      <div className="max-w-7xl mx-auto px-6">
        {/* 上部内容 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* 左栏 - 品牌信息 */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img src="https://static.readdy.ai/image/a68e6275e3edc3dffa3b1dce13502b4a/e4c5d2d87fb7ab856d386f6e17f08b6c.png" alt="Logo" className="h-12 w-12" />
              <h3 className="text-3xl font-black">智创灵眸</h3>
            </div>
            <p className="text-base text-gray-400 leading-relaxed mb-6">
              构建海陆空天一体化智能感知网络,赋能港口数字化转型
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:border-teal-500 hover:text-teal-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:border-teal-500 hover:text-teal-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:border-teal-500 hover:text-teal-500 transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:border-teal-500 hover:text-teal-500 transition-colors cursor-pointer">
                <i className="ri-youtube-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* 中栏 - 联系信息 */}
          <div className="space-y-6">
            <div>
              <h4 className="text-sm text-gray-500 mb-2 tracking-wider">地址 ADDRESS</h4>
              <p className="text-base text-white">
                上海市浦东新区<br />
                临港新片区环湖西二路888号
              </p>
            </div>
            <div>
              <h4 className="text-sm text-gray-500 mb-2 tracking-wider">电话 PHONE</h4>
              <p className="text-base text-white">+86 21 5888 8888</p>
            </div>
            <div>
              <h4 className="text-sm text-gray-500 mb-2 tracking-wider">邮箱 EMAIL</h4>
              <p className="text-base text-white">contact@smartport.com</p>
            </div>
          </div>

          {/* 右栏 - 资质展示 */}
          <div>
            <div className="w-full h-64 bg-gradient-to-br from-teal-500/20 to-transparent border border-teal-500/30 rounded-lg flex items-center justify-center">
              <div className="text-center">
                <i className="ri-award-line text-6xl text-teal-400 mb-4"></i>
                <p className="text-sm text-gray-400">国家高新技术企业</p>
                <p className="text-sm text-gray-400">ISO 9001认证</p>
              </div>
            </div>
          </div>
        </div>

        {/* 底部版权 */}
        <div className="border-t border-teal-500/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
            <p>© 2025 智创灵眸. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">隐私政策</a>
              <span>|</span>
              <a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">服务条款</a>
              <span>|</span>
              <a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">网站地图</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}